/**
 * @function isSessionSelectionControlsVisible
 * @description
 * Determines if the session selection controls should be visible for the given
 * event and session.
 *
 * @param {Object} event - The event that the session is part of.
 * @param {Object} session - The session to check.
 *
 * @returns {Boolean}   `true` if the session selection controls should be visible, `false` otherwise.
 */
export function isSessionSelectionControlsVisible(event, session) {
    return event.settings?.workshop_selection && session.is_selectable;
}
